module.exports = __webpack_public_path__ + "img/az.dd21cf16.png";